export default "__VITE_ASSET__7fyx8DNS__"